import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for fetching orders
export const fetchOrdersByUserId = createAsyncThunk('orders/fetchOrdersByUserId', async (userId) => {
  const response = await fetch(`/api/orders/user/${userId}`);
  const data = await response.json();
  return data;
});

const ordersByUserIdSlice = createSlice({
  name: 'orders',
  initialState: { orders: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrdersByUserId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOrdersByUserId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.orders = action.payload;
      })
      .addCase(fetchOrdersByUserId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default ordersByUserIdSlice.reducer;